/*******************************************************************************
 *** Welcome ** 회원가입 완료
 *******************************************************************************/
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import React from "react";
import Util from '../common/Util';
import AppContext from '../common/AppContext';

const Welcome = () => {
    const params = useParams();
    const navigate = useNavigate();

    const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth <= 768;
    const pageSidePadding = isMobile ? 16 : 24;
    const cardWidth = Math.min(600, windowWidth - (pageSidePadding * 2));
    const buttonWidth = Math.min(cardWidth - (isMobile ? 32 : 40), Math.floor(cardWidth * 0.8));

    return (
        <div
            className='w100p dpFlx flxdCol aiC jcC'
            style={{
                minHeight: "100dvh",
                backgroundColor: "#f6f7f9",
                boxSizing: "border-box",
                paddingLeft: pageSidePadding,
                paddingRight: pageSidePadding,
                paddingTop: isMobile ? 20 : 0,
                paddingBottom: isMobile ? 20 : 24
            }}
        >
            <div
                className="bgcWhite bsOut bsBdb"
                style={{
                    width: cardWidth,
                    borderRadius: 10,
                    boxSizing: "border-box",
                    padding: isMobile ? "28px 16px 32px 16px" : "40px 20px 40px 20px"
                }}
            >
                <div className='w100p dpFlx aiC jcC'>
                    <img
                        src={Util.getImgSrc("common/logo.png")}
                        width={isMobile ? 170 : 238}
                        height={isMobile ? 58 : 81}
                        alt="logo"
                    />
                </div>

                <div
                    className='w100p dpFlx aiC jcC'
                    style={{
                        paddingTop: isMobile ? 28 : 40,
                        paddingBottom: isMobile ? 24 : 40
                    }}
                >
                    <span
                        className="fcBlack fw700"
                        style={{
                            fontSize: isMobile ? 30 : 40,
                            letterSpacing: -1,
                            marginLeft: 0,
                            textAlign: "center",
                            lineHeight: 1.2
                        }}
                    >
                        회원가입 완료
                    </span>
                </div>

                <div
                    className='w100p dpFlx aiC jcC'
                    style={{
                        paddingLeft: isMobile ? 4 : 12,
                        paddingRight: isMobile ? 4 : 12
                    }}
                >
                    <div
                        className='Pretendard-Medium taC'
                        style={{
                            fontSize: isMobile ? 17 : 20,
                            letterSpacing: -0.5,
                            fontWeight: 500,
                            lineHeight: isMobile ? "30px" : "36px",
                            margin: 0,
                            wordBreak: "keep-all"
                        }}
                    >
                        <span className='fc007bff'>{params.userNm}</span>
                        <span className='fc2C2C2C'>
                            회원님 전국우정노동조합의 회원이 되신 것을 환영합니다!
                        </span>

                        <p
                            className='fc777777'
                            style={{
                                margin: isMobile ? "14px 0 0 0" : "16px 0 0 0",
                                lineHeight: isMobile ? "28px" : "36px"
                            }}
                        >
                            관리자에게 회원가입에 대해 승인 요청하였습니다.
                            <br />
                            <span className='fc4E4E4E'>
                                관리자가 승인한 후 시스템을 사용하실 수 있습니다.
                            </span>
                        </p>
                    </div>
                </div>

                <div
                    className='w100p dpFlx aiC jcC'
                    style={{
                        marginTop: isMobile ? 20 : 20,
                        paddingLeft: isMobile ? 4 : 0,
                        paddingRight: isMobile ? 4 : 0
                    }}
                >
                    <span
                        className='Pretendard-Regular'
                        style={{
                            fontSize: isMobile ? 17 : 20,
                            letterSpacing: -0.18,
                            textAlign: "center",
                            wordBreak: "break-all",
                            lineHeight: isMobile ? "28px" : "32px"
                        }}
                    >
                        <span className='fc666666' style={{paddingRight: 10}}>아이디</span>
                        <span className='fc4E4E4E fwB'>{params.userId}</span>
                    </span>
                </div>

                <div
                    className='dpFlx jcC aiC'
                    style={{
                        marginTop: isMobile ? 32 : 50
                    }}
                >
                    <button
                        type="button"
                        className='dpFlx aiC jcC csP'
                        style={{
                            width: buttonWidth,
                            height: isMobile ? 54 : 62,
                            backgroundColor: AppContext.themeColor,
                            borderRadius: 10,
                            border: "none",
                            outline: "none"
                        }}
                        onClick={() => navigate('/portal/login')}
                    >
                        <span
                            className="Pretendard-Bold fcWhite"
                            style={{
                                fontSize: isMobile ? 18 : 20,
                                letterSpacing: 0
                            }}
                        >
                            확인
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Welcome;